import { atom } from 'jotai';

export const selectRevieweeOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const assignReviewerOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const selectTemplateOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const questionnaireCreationOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const scheduleCreationOnNextAtom = atom<(() => Promise<boolean>) | null>(null);
export const lastSavedAtAtom = atom<Date | null>(null);
